import React from 'react'
import { shallow } from 'enzyme'

import { SmartRateModal } from '../SmartRateModal'
import ModalHeader from '../ModalHeader'
import ModalBody from '../ModalBody'

describe('<SmartRateModal />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {}
    wrapper = shallow(<SmartRateModal {...props} />)
  })
  it('should render a <ModalHeader />', () => {
    expect(wrapper.find(ModalHeader)).toHaveLength(1)
  })
  it('should render a <ModalBody />', () => {
    expect(wrapper.find(ModalBody)).toHaveLength(1)
  })
})
